module.exports = __webpack_public_path__ + "static/utekirkelogokors-af29bd2df44b3d456e7fea5e61b6ffb2.png";